module.exports = __webpack_public_path__ + "img/pc.cb91d17c.svg";